import { CdkAccordionItem } from '@angular/cdk/accordion';
import { ChangeDetectionStrategy, Component, effect, inject, input, output, viewChild } from '@angular/core';
import { ScrollService } from '@big-direkt/utils/environment';
import { IconBigMediumPlus, IconBigMediumSchliessen, IconComponent } from '@big-direkt/utils/icons';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'big-ui-accordion-item',
    templateUrl: './accordion-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CdkAccordionItem, IconComponent, TranslocoDirective],
    host: {
        class: 'block mb-4 last:mb-0',
    },
})
export class AccordionItemComponent {
    private readonly scrollService = inject(ScrollService);

    public readonly iconPlus = IconBigMediumPlus;
    public readonly iconClose = IconBigMediumSchliessen;

    public readonly index = input.required<number>();
    public readonly title = input.required<string>();
    public readonly isOpen = input<boolean>(false);
    public readonly openForPrint = input<boolean>(false);
    public readonly customClass = input<string>('bg-white');

    public readonly opening = output<number>();

    public readonly accordionItem = viewChild(CdkAccordionItem);

    public constructor() {
        effect(() => {
            if (!this.accordionItem()) {
                return;
            }

            if (this.isOpen()) {
                this.accordionItem()?.open();
            } else {
                this.accordionItem()?.close();
            }
        });
    }

    public itemClicked(accordionItem: CdkAccordionItem): void {
        accordionItem.toggle();

        if (accordionItem.expanded) {
            this.opening.emit(this.index());

            const scrollSelector = `#${accordionItem.id}`;
            this.scrollService.scroll(scrollSelector, { scrollIntoView: true, scrollIntoViewOptions: { block: 'end' } });
        }
    }
}
